import { useSearchParams } from 'next/navigation';

import { selectCelebrationsIsFlowActive } from '@/ducks/programs/celebrations/selectors';
import { selectSelectedPackageFromMainPackages } from '@/ducks/voyageInfo/sailing/selectors';
import useCmsValues from '@/hooks/useCmsValues';
import { useAppSelector } from '@/store';

export const useGetImageOfShownSailing = (src?: string) => {
  const searchParams = useSearchParams();

  const celebrationImage = useCmsValues('celebrations.largeImage.@link')?.[0];
  const isCelebrationActive = useAppSelector(selectCelebrationsIsFlowActive);

  const selectedPackageImage = useAppSelector(
    (state) => selectSelectedPackageFromMainPackages(state, searchParams)?.landscapeHero?.src,
  );

  return isCelebrationActive ? celebrationImage : src || selectedPackageImage;
};
